module.exports = __webpack_public_path__ + "media/images/svg/robles_sphere_text-f9d9998c87c34ae8db5baf0cb5725067.svg";